import { Consts } from "../../pages/consts";
import DayTimeIntake from "./DayTimeIntake";

const DayTimeIntakes = ({timingType, intakes, onSetIntake}) => {
  return (
    <section className="daytime-intakes">
      {timingType === Consts.DAY_TIMES && (
        <div className="daytime-intakes__content">
          <div className="daytime-intakes__grid">
            {intakes?.map((intake, i) => {
              return (
                <div
                  className="daytime-intakes__item"
                  key={`dayTimeIntake${i}`}
                >
                  <DayTimeIntake index={i} intake={intake} onSetIntake={onSetIntake}/>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
};

export default DayTimeIntakes;
